import {
  ArrayInput,
  Edit,
  NumberInput,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
} from "@/components/admin"
import { RaRecord, useGetIdentity, useSourceContext } from "ra-core"
import { ReactElement } from "react"
import { useWatch } from "react-hook-form"
const RoomEdit = (): ReactElement => {
  const { data: identity } = useGetIdentity()

  return (
    <Edit
      title={false}
      className="py-6"
      mutationMode="optimistic"
      transform={(data: RaRecord) => ({
        ...data,
        updated_at: new Date().toISOString(),
        updated_by: identity?.id,
      })}
      redirect={(resource, id, data: any) => {
        console.log(resource, id)
        return `/projects/${data.project_id}/edit`
      }}
    >
      <SimpleForm>
        <div className="grid lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-6 xs:grid-cols-6 gap-4 pb-16">
          <TextInput source="title" />

          <SelectInput
            source="type"
            choices={[
              { id: "room", name: "Pièce" },
              { id: "bedroom", name: "Chambre" },
              { id: "kitchen", name: "Cuisine" },
              { id: "wc", name: "Toilettes (WC)" },
              { id: "bathroom", name: "Salle de bain" },
              { id: "garage", name: "Garage" },
            ]}
          />
          <div className="grid  md:col-span-2 sm:col-span-2 w-full sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 ">
            <TextInput source="description" />
          </div>
          <NumberInput source="surface" />
          <NumberInput source="windows" />
          <NumberInput source="balconies" />
          <ReferenceInput reference="project_phases" source="status">
            <SelectInput />
          </ReferenceInput>
        </div>
        <ArrayInput source="material_ids">
          <SimpleFormIterator inline>
            <SelectInput
              source="category"
              optionText="id"
              choices={[
                {
                  id: "Foundation & Earthworks",
                },
                {
                  id: "Finishing Materials",
                },
                {
                  id: "Mechanical & Electrical",
                },
                {
                  id: "Sustainability & Green",
                },
                {
                  id: "Waterproofing & Insulation",
                },
                {
                  id: "Structural Materials",
                },
                {
                  id: "Road & Pavement",
                },
                {
                  id: "Smart / Emerging",
                },
                {
                  id: "Ancillary",
                },
              ]}
            />
            <FiltredMaterialsInput source="mid" />
            <NumberInput source="quantity" />
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Edit>
  )
}

export default RoomEdit

const FiltredMaterialsInput = ({ source }: { source: string }) => {
  const sourceContext = useSourceContext()
  const category = useWatch({ name: sourceContext.getSource("category") })

  return (
    <ReferenceInput source={source} reference="materials" filter={{ category }}>
      <SelectInput label="Matériel" disabled={!category} optionValue="id" />
    </ReferenceInput>
  )
}
